export const environment = {
  production: true,
  keycloakUrl: '__KEYCLOAK_URL__',
  keycloakRealm: 'ensys',
  keycloakClientId: 'ensys-users'
};
